<template>
  <div class="vimeo" v-html="iframe">
  </div>
</template>

<script>
function fetchIframe (url) {
  const apiParams = 'color=ea445b';
  const apiURL = `https://vimeo.com/api/oembed.json?url=${url}&${apiParams}`;

  return window.fetch(apiURL)
    .then(r => r.json())
    .then(result => result.html);
}

export default {
  name: 'vimeo-embed',
  props: [
    'url'
  ],
  data () {
    return {
      iframe: ''
    };
  },
  created () {
    const { url } = this.$props;

    fetchIframe(url)
      .then((iframe) => {
        this.iframe = iframe;
      });
  }
}
</script>

<style lang="scss">
.vimeo {
  width: 100%;
  iframe {
    width: 100%;
    height: 508px;

    @media only screen and (max-width: 512px) { 
      height: 200px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// VimeoEmbed.vue?42f67d50